<template>
  <div>
    <van-empty
      class="custom-image"
      :image="require('@/assets/result-empty.png')"
      :description="
        tag == true
          ? '您在近三天内没有参与答题，赶快来参与吧～'
          : '您还没有参与答题，赶快来参与吧～'
      "
    />
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-image {
  padding-top: 120px;
  .van-empty__image {
    width: 152px;
    height: 128px;
  }
  ::v-deep .van-empty__description {
    margin-top: 20px;
    line-height: 20px;
    color: $gray-color;
  }
}
</style>
